import { Button } from "primereact/button";
import { genElText } from "../../../../components/utils/EditorDialogElementGenerator";
import { useSelector } from "react-redux";

const CustomerSelectorFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;
  const employee = useSelector((state) => state.auth.employee);

  const elBc = genElText({
    field: 'bc',
    name: 'BC',
    data: filterValue,
    setData: setFilterValue,
    error: {},
    onEnter: () => { if (onClickRefresh) onClickRefresh(); },
  });

  const elCode = genElText({
    field: 'code',
    name: 'Code',
    data: filterValue,
    setData: setFilterValue,
    error: {},
    onEnter: () => { if (onClickRefresh) onClickRefresh(); },
  });

  const elName = genElText({
    field: 'name',
    name: 'Name',
    data: filterValue,
    setData: setFilterValue,
    error: {},
    onEnter: () => { if (onClickRefresh) onClickRefresh(); },
  });

  return (
    <div className="row-between-end gap-4 w-full">
      {/* filter component section */}
      <div className="row-start-center gap-4 w-full">
        {employee?.user_type != 3 && elBc}
        {elCode}
        {elName}
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default CustomerSelectorFilter;
